import { render, staticRenderFns } from "./exchange-configuration-modal.component.vue?vue&type=template&id=0f42e9ac&scoped=true&"
import script from "./exchange-configuration-modal.component.vue?vue&type=script&lang=ts&"
export * from "./exchange-configuration-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./exchange-configuration-modal.component.vue?vue&type=style&index=0&id=0f42e9ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f42e9ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VDialog,VDivider,VIcon,VProgressCircular,VSelect})
